const footerLinks = [
  {
    title: '漫画分类',
    items: ['韩漫大全', '日漫大全', '国漫大全', '热血漫画', '恋爱漫画', '奇幻漫画'],
  },
  {
    title: '热门推荐',
    items: ['漫画排行榜', '新番速递', '高分必看', '编辑精选', '完结推荐', '经典回顾'],
  },
  {
    title: '帮助中心',
    items: ['常见问答', '阅读指南', '更新说明', '联系我们'],
  },
];

export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                scrollTo('#hero');
              }}
              className="inline-block text-xl md:text-2xl font-heading font-bold text-white mb-4 cursor-pointer"
            >
              YY漫画网
            </a>
            <p className="text-foreground-400 text-sm leading-relaxed mb-5 max-w-xs">
              YY漫画网提供韩漫、日漫、国漫等分类大全，好看的漫画排行榜推荐，
              免费漫画分类浏览，全集漫画免费下拉式阅读，热门漫画追更在线看。
            </p>
            <div className="flex items-center gap-3">
              <a href="#contact" onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }} className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-white"></i>
                </span>
              </a>
              <a href="#comments" onClick={(e) => { e.preventDefault(); scrollTo('#comments'); }} className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-chat-1-line text-white"></i>
                </span>
              </a>
              <a href="#ranking" onClick={(e) => { e.preventDefault(); scrollTo('#ranking'); }} className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-fire-line text-white"></i>
                </span>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h3 className="text-sm font-semibold text-white mb-4">{group.title}</h3>
              <ul className="space-y-2.5">
                {group.items.map((item) => (
                  <li key={item}>
                    <a
                      href="#cards"
                      onClick={(e) => {
                        e.preventDefault();
                        scrollTo('#cards');
                      }}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/10 mt-12 pt-8">
          <div className="mb-6">
            <h3 className="text-xs font-semibold text-foreground-400 uppercase tracking-wide mb-3">合作伙伴</h3>
            <div className="flex flex-wrap gap-3">
              {[...Array(6)].map((_, i) => (
                <div
                  key={i}
                  className="px-4 py-2 rounded-lg bg-white/5 border border-white/10"
                >
                  <span className="text-xs text-foreground-500">合作品牌 {i + 1}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} YY漫画网. 本站内容仅供学习交流，版权归原作者所有。
            </p>
            <div className="flex items-center gap-6">
              <a
                href="#faq"
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo('#faq');
                }}
                className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
              >
                常见问答
              </a>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo('#contact');
                }}
                className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
              >
                联系我们
              </a>
              <span className="text-xs text-foreground-600">contact@yymanhua.com</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}